
<template>
    <div class="content-wrapper">
      <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
       {{actionToBePerformed}}
      </h1>
      <ol class="breadcrumb">
        <li><a href="#"><i class="fa fa-dashboard"></i> Home</a></li>
        <li><router-link to="/offering-manager/view">Back</router-link></li>        
        <li class="active">Create / Update Offering</li>
      </ol>
    </section>

    <section class="content">
        <div class="row">
        <div class="col-xs-12">
          <div class="box">
            <div class="box-body">
              <div class="col-xs-12 col-md-12 col-lg-12">
                <form @submit.prevent="createOrUpdateOffering" action="#"  method="post">
                  <div class="panel panel-default">
                    <div class="panel-heading">
                      <h3 class="panel-title">Offering Configuration</h3>
                    </div>
                    <div class="panel-body">
                      <div class="row">
                        <div class="col-md-12 col-lg-12 col-xs-12">
                          <div class="form-group col-xs-6 col-sm-6 col-md-6">
                            <label for="legacy_name" class="required">Offering Name (internal)</label>
                            <input type="text" v-bind:class="{'form-group--error': submitted && !$v.gRowObj.legacy_name.required }" v-model="gRowObj.legacy_name" class="form-control" id="legacy_name" placeholder="Offering Name"  />
                            <span v-if="submitted && !$v.gRowObj.legacy_name.required" class="text-red pull-right">Please enter offering name.</span>
                          </div>

                          <div class="form-group col-xs-6 col-sm-6 col-md-6">
                            <label for="snomed_code">Metadata (snomed code)</label>
                            <input type="snomed_code" v-model="gRowObj.snomed_code" class="form-control" id="name" placeholder="Snomed Code"  />
                          </div>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-md-12 col-lg-12 col-xs-12">
                            <div class="form-group col-xs-6 col-sm-6 col-md-6">
                              <label for="short_name" class="required">Short Name (Code abbreviation)</label>
                              <input type="text" v-bind:class="{'form-group--error': submitted && !$v.gRowObj.short_name.required }" v-model="gRowObj.short_name" class="form-control" id="name" placeholder="Short Name"  />
                              <span v-if="submitted && !$v.gRowObj.short_name.required" class="text-red pull-right">Please enter short name.</span>
                            </div>

                            <div class="form-group col-xs-6 col-sm-6 col-md-6">
                              <label for="name" class="required">Offering Type</label>
                            <nv-select class="form-control" v-bind:class="{'form-group--error': submitted && !$v.gRowObj.type.required }" 
                              id="type" v-model="gRowObj.type">
                                <option value="">--Choose an offering--</option>
                                <option v-for="data in offeringType" 
                                :selected="data.value === gRowObj.type" :key="data.value" :value="data.value">{{data.name}}</option>                    
                              </nv-select>
                              <span v-if="submitted && !$v.gRowObj.type.required" class="text-red pull-right">Please choose an offering type.</span>
                          </div>

                           
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-md-12 col-lg-12 col-xs-12">
                            <div class="form-group col-xs-6 col-sm-6 col-md-6">
                              <label for="attributes">Offering Attributes</label>
                              <textarea :key="invalidAttributes" v-bind:class="{'form-group--error': submitted && invalidAttributes}"  style="height:100px" type="text" v-model="gRowObj.attributes" class="form-control" id="name" placeholder="Offering attributes" @input="checkAttributes()"/>
                              <span :key="invalidAttributes" v-if="submitted && invalidAttributes" class="text-red pull-right">Please enter valid JSON.</span>
                            </div>
                        </div>
                      </div>

                          <div class="panel panel-default">
                            <div class="panel-heading">
                              <h3 class="panel-title">Display Name</h3>
                            </div>
                            <div class="panel-body">
                              <div class="row">
                                <div class="col-md-12 col-lg-12 col-xs-12">
                                  <div class="form-group col-xs-6 col-sm-6 col-md-6">
                                    <label for="short_name">Country</label>
                                    <nv-select class="form-control"
                                      v-model="messageSet.country" @change="getLanguagesInCountry()">
                                      <option value="">--Choose a country--</option>
                                      <option v-for="data in countryList" :selected="data.country_id === messageSet.country"
                                        :key="data.country_id" :value="data.country_name">{{data.country_name}}</option>
                                    </nv-select>
                                  </div>

                                  <div class="form-group col-xs-6 col-sm-6 col-md-6">
                                    <label for="name">Language</label>
                                    <nv-select class="form-control" v-model="messageSet.language">
                                      <option value="">--Choose language--</option>
                                      <option v-for="(value, index) in languages" :key="index" :value="value.alias">
                                        {{value.name}}</option>
                                    </nv-select>
                                  </div>
                                </div>
                              </div>

                              <div class="row">
                                <div class="col-md-12 col-lg-12 col-xs-12">
                                  <div class="col-md-6 col-lg-6 col-xs-6">
                                    <textarea class="form-control" v-model="messageSet.message" placeholder="message" />
                                  </div>
                                  <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1">
                                    <label for="property">&nbsp;</label>
                                    <i class="fa fa-plus-circle add-property" aria-hidden="true" @click="addMessageSet()"></i>
                                  </div>
                                </div>
                              </div>


                              <table v-if="Object.keys(messages).length" class="table table-striped margin-top-20">
                                <thead>
                                  <th class="width-100">Country</th>
                                  <th class="width-100">Language</th>
                                  <th>Text</th>
                                  <th>Edit</th>
                                  <th>Delete</th>
                                </thead>
                                <tbody v-for="(value, key) in messages" :key="key">
                                    <tr v-bind:key="language" v-for="(messageRow, language, iSub) in value">
                                      <td style="width:10%; background-color: #e8e8e8;" :rowspan="Object.keys(value).length"
                                        v-if="iSub === 0">
                                        <h4><strong>{{key}}</strong></h4>
                                      </td>
                                      <td style="width:7%; background-color: #f3f2f2;"><strong>
                                          <h4>{{language}}</h4>
                                        </strong></td>
                                      <td style="width:71%">{{messageRow}}</td>
                                      <td style="width:6%"><i class="fa fa fa-pencil" v-on:click="editTranslation(language,key)"
                                          aria-hidden="true"></i></td>
                                      <td style="width:6%"><i class="fa fa-times-circle"
                                          v-on:click="deleteTranslation(value,language, key)" aria-hidden="true"></i></td>
                                    </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                       

                    </div>
                    </div>


                  <div class="row">
                  </div>
                  <div class="row">
                    <div class="action-button">
                      <button type="button" class="btn btn-primary" @click="close">Cancel</button>
                      <input type="submit" class="btn btn-primary margin-left-20px" value="Submit">
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div> 
        </div>
      </div>

    </section>
    <BlockUI v-if="loading"><i class="fa fa-cog fa-spin fa-3x fa-fw"></i><br/>Please wait...</BlockUI>
    </div>
</template>
<script>
  import { required } from 'vuelidate/lib/validators'
  import api from '../../../utils/api'
  import { offeringType } from '../../../config/constants'
  export default {
    name: 'modal',
    validations: {
      gRowObj: {
        legacy_name: { required },
        short_name: { required },
        type: { required }
      }
    },
    data () {
      return {
        loading: false,
        isEdit: false,
        offeringType: offeringType,
        invalidAttributes: false,
        gRowObj: {
          id: null,
          legacy_name: '',
          short_name: '',
          snomed_code: '',
          type: '',
          attributes: ''
        },
        messageSet: {
          country: '',
          language: '',
          message: ''
        },
        submitted: false,
        actionToBePerformed: 'Create Offering',
        languages: [],
        countryAndLanguages: [],
        countryList: [],
        messages: {},
        isEdited: false,
        allMessages: [],
        index: -1,
        languageMap: {},
        countryMap: {}
      }
    },
    methods: {
      log (val) {
        console.log('d', val)
      },
      close () {
        this.$router.replace('/offering-manager/view')
      },

      checkAttributes () {
        try {
          if (this.gRowObj.attributes) {
            JSON.parse(this.gRowObj.attributes)
          }
          this.invalidAttributes = false
        } catch (e) {
          this.invalidAttributes = true
        }
      },

      editTranslation (language, country) {
        this.messageSet.country = country
        this.languages = this.countryAndLanguages[this.messageSet.country]
        this.messageSet.language = language
        this.messageSet.message = this.messages[country][language]
      },

      deleteTranslation (value, language, country) {
        if (Object.keys(this.messages).length === 1 && Object.keys(this.messages[country]).length === 1) {
          this.messages = {}
        } else {
          const countryLangObj = JSON.parse(JSON.stringify(this.messages))
          if (Object.keys(this.messages[country]).length === 1) {
            delete countryLangObj[country]
          } else {
            delete countryLangObj[country][language]
          }
          this.messages = countryLangObj
        }
      },
      async getLanguages () {
        try {
          this.loading = true
          const response = await api.buildRequest('languages', 'GET')
          this.countryAndLanguages = response.data.payload
          this.loading = false
        } catch (error) {
          this.loading = false
          this.$swal({
            type: 'error',
            text: error.response ? error.response.data.payload.message : 'An error occurred'
          })
        }
      },

      async getAllSupportedLanguages () {
        try {
          this.loading = true
          const response = await api.buildRequest('getAllSupportedLanguages', 'POST')
          response.data.payload.forEach(lang => {
            this.languageMap[lang.alias] = lang.id
          })
          this.loading = false
        } catch (error) {
          this.loading = false
          this.$swal({
            type: 'error',
            text: error.response ? error.response.data.payload.message : 'An error occurred'
          })
        }
      },

      addMessageSet () {
        console.log('inside addLanguageTranslation')
        console.log(this.messageSet.message)
        this.messages = JSON.parse(JSON.stringify(this.messages))
        if (this.messageSet.language && this.messageSet.message) {
          if (this.messages[this.messageSet.country]) {
            this.messages[this.messageSet.country][this.messageSet.language] = this.messageSet.message
          } else {
            this.messages[this.messageSet.country] = {}
            this.messages[this.messageSet.country][this.messageSet.language] = this.messageSet.message
          }
          console.log(this.messages)
          this.messageSet.language = ''
          this.messageSet.message = ''
          this.messageSet.country = ''
        } else {
          this.$swal({
            type: 'error',
            text: 'You must select a language & enter a text'
          })
        }
      },

      async getCountryList () {
        try {
          this.loading = true
          const response = await api.buildRequest('getCountryList', 'POST')
          this.countryList = response.data.payload
          response.data.payload.forEach(country => {
            this.countryMap[country.country_name] = country.country_id
          })
          this.loading = false
        } catch (error) {
          this.loading = false
          this.$swal({
            type: 'error',
            text: error.response ? error.response.data.payload.message : 'An error occurred'
          })
        }
      },

      getLanguagesInCountry () {
        if (!this.messageSet.country) {
          this.languages = []
        } else {
          // const country = this.countryList.filter(country => country.country_id === this.messageSet.country)[0]
          this.languages = this.countryAndLanguages[this.messageSet.country]
        }
      },
      getByValue (map, searchValue) {
        for (let key of Object.keys(map)) {
          if (searchValue === map[key]) {
            return key
          }
        }
      },
      async getOfferingDetails (id) {
        const param = {
          id: id
        }
        this.loading = true
        return new Promise(resolve => {
          api.buildRequest('getOfferingDetails', 'POST', param).then(async ({ data }) => {
            if (data && data.payload && data.payload) {
              const objRes = data.payload.details
              this.gRowObj.id = objRes.id
              this.gRowObj.legacy_name = objRes.legacy_name
              this.gRowObj.short_name = objRes.short_name
              this.gRowObj.snomed_code = objRes.snomed_code
              this.gRowObj.type = objRes.type
              this.gRowObj.attributes = objRes.offering_attributes ? JSON.stringify(objRes.offering_attributes, null, 4) : ''
            }
            const msg = data.payload.messageSet
            let messageObj = {}
            msg.forEach(ms => {
              let countryName = this.getByValue(this.countryMap, ms.country_id)
              let languageName = this.getByValue(this.languageMap, ms.language_id)
              let langObj = messageObj && messageObj[countryName] ? {...messageObj[countryName]} : {}
              langObj[languageName] = ms.display_text
              messageObj[countryName] = langObj
            })
            console.log('msg', messageObj)
            this.messages = messageObj
            this.loading = false
            resolve(true)
          }).catch(({ response }) => {
            resolve(true)
            this.loading = false
            this.$swal({
              type: 'error',
              text: response ? response.data.payload.message : 'An error occurred'
            })
          })
        })
      },
      async createOrUpdateOffering () {
        let messageSets = []
        Object.keys(this.messages).forEach((country) => {
          const languages = this.messages[country]
          Object.keys(languages).forEach((lang) => {
            const obj = { country_id: this.countryMap[country], language_id: this.languageMap[lang], display_text: this.messages[country][lang] }
            messageSets.push(obj)
          })
        })
        console.log('messageSets', messageSets)
        this.submitted = true
        this.$v.gRowObj.$touch()
        if (this.$v.gRowObj.$invalid || (this.gRowObj.attributes && this.invalidAttributes)) {
          return
        }

        this.loading = true
        let param = {
          id: this.gRowObj.id,
          legacy_name: this.gRowObj.legacy_name.trim(),
          short_name: this.gRowObj.short_name.trim(),
          snomed_code: this.gRowObj.snomed_code && this.gRowObj.snomed_code.trim(),
          type: this.gRowObj.type,
          offering_attributes: this.gRowObj.attributes ? JSON.parse(this.gRowObj.attributes) : null,
          messageSets
        }
        param.id = param.id ? param.id : null
        param.snomed_code = param.snomed_code ? param.snomed_code : null
        if (this.gRowObj.id) {
          // -- call edit
          return new Promise(resolve => {
            api.buildRequest('updateOffering', 'POST', param).then(() => {
              this.loading = false
              this.$swal({
                type: 'success',
                text: 'Offering updated successfully'
              }).then(() => {
                this.$router.push({ name: 'offering-manager/view' })
              })
              resolve()
            }).catch(({ response }) => {
              resolve(true)
              this.loading = false
              this.$swal({
                type: 'error',
                text: response ? response.data.payload.message : 'An error occurred'
              })
            })
          })
        } else {
          // -- call creat
          return new Promise(resolve => {
            api.buildRequest('createOffering', 'POST', param).then(() => {
              this.loading = false
              this.$swal({
                type: 'success',
                text: 'Offering created successfully'
              }).then(() => {
                this.$router.push({ name: 'offering-manager/view' })
              })
              resolve()
            }).catch(({ response }) => {
              resolve(true)
              this.loading = false
              this.$swal({
                type: 'error',
                text: response ? response.data.payload.message : 'An error occurred'
              })
            })
          })
        }
      }
    },
    async mounted () {
      this.gRowObj = {
        id: null,
        legacy_name: '',
        short_name: '',
        snomed_code: '',
        type: ''
      }
      await this.getLanguages()
      await this.getCountryList()
      await this.getAllSupportedLanguages()
      if (this.$route && this.$route.query && this.$route.query.offeringId) {
        this.actionToBePerformed = 'Update Offering'
        this.isEdit = true
        await this.getOfferingDetails(this.$route.query.offeringId)
      }
      this.loading = false
    }
  }
</script>
<style>
.margin-top-20 {
  margin-top: 20px;
}
.width-100 {
  min-width: 100px;
}
</style>



// WEBPACK FOOTER //
// createOrUpdateOffering.vue?5242d6e4